export default "__VITE_ASSET__DhsudIhJ__"